import React from 'react'

type Props = {}

const AboutPage = (props: Props) => {
  return (
    <div>AboutPage</div>
  )
}

export default AboutPage